export const APPOINTMENT_SUCCESSFUL = "APPOINTMENT_SUCCESSFUL";
export const APPOINTMENT_FAIL = "APPOINTMENT_FAIL";
